var Z = Object.defineProperty, ee = Object.defineProperties;
var te = Object.getOwnPropertyDescriptors;
var E = Object.getOwnPropertySymbols;
var oe = Object.prototype.hasOwnProperty, ae = Object.prototype.propertyIsEnumerable;
var A = (c, a, o) => a in c ? Z(c, a, { enumerable: !0, configurable: !0, writable: !0, value: o }) : c[a] = o, x = (c, a) => {
  for (var o in a || (a = {}))
    oe.call(a, o) && A(c, o, a[o]);
  if (E)
    for (var o of E(a))
      ae.call(a, o) && A(c, o, a[o]);
  return c;
}, j = (c, a) => ee(c, te(a));
var K = (c, a, o) => new Promise((S, C) => {
  var m = (p) => {
    try {
      y(o.next(p));
    } catch (i) {
      C(i);
    }
  }, r = (p) => {
    try {
      y(o.throw(p));
    } catch (i) {
      C(i);
    }
  }, y = (p) => p.done ? S(p.value) : Promise.resolve(p.value).then(m, r);
  y((o = o.apply(c, a)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { getMarketRightDetail as ne } from "../../request/ucenterapi/internal/business/marketRightDetail/get.js";
import { getDictLabelSync as re, getDict as le } from "@oppein/op-utils";
import se from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/tooltip/src/Tooltip.js";
import { defineComponent as ie, useTemplateRef as ue, onMounted as de, openBlock as ce, createElementBlock as ge, createElementVNode as V, createVNode as w, withCtx as R, createTextVNode as z, Fragment as pe, h as T } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as fe } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { ref as h, unref as k } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import me from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import he from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import ye from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/data-table/src/DataTable.js";
import H from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import ve from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
import we from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/radio/src/Radio.js";
const ke = {
  style: {
    width: "100%",
    display: "flex",
    "justify-content": "center",
    "margin-top": "20px"
  }
}, Pe = /* @__PURE__ */ ie({
  __name: "ManagementList",
  emits: ["submit"],
  setup(c, {
    expose: a,
    emit: o
  }) {
    const S = ue("relatedApprovalContainer"), C = fe(), m = h(!1), r = h([]), y = h(!0), p = h(0), i = h([]), O = h(!1), v = h(""), U = [
      {
        title: "选择",
        key: "selection",
        width: 60,
        align: "center",
        render: (e) => T(we, {
          checked: r.value.includes(e.uniqueKey),
          onUpdateChecked: (n) => {
            if (n) {
              const t = i.value.filter((s) => s.orgMarketManageRightCode === e.orgMarketManageRightCode), l = [...r.value];
              t.forEach((s) => {
                l.includes(s.uniqueKey) || l.push(s.uniqueKey);
              }), y.value ? r.value = t.map((s) => s.uniqueKey) : r.value = l;
            } else {
              const t = i.value.filter((l) => l.orgMarketManageRightCode === e.orgMarketManageRightCode);
              r.value = r.value.filter((l) => !t.some((s) => s.uniqueKey === l));
            }
          }
        }),
        rowSpan: (e) => e.rowSpan || 1
      },
      {
        title: "经营权编码",
        key: "orgMarketManageRightCode",
        width: 120,
        rowSpan: (e) => e.rowSpan || 1
      },
      {
        title: "所属事业线",
        key: "orgBelongMarketClassifyName",
        width: 160,
        rowSpan: (e) => e.rowSpan || 1
      },
      {
        title: "所属经销部",
        key: "orgBelongClassifySalesName",
        width: 130,
        rowSpan: (e) => e.rowSpan || 1
      },
      {
        title: "所属线别",
        key: "orgBelongClassifyName",
        width: 120,
        rowSpan: (e) => e.rowSpan || 1
      },
      {
        title: "经销部管理员",
        key: "orgStoreAdminName",
        width: 120,
        rowSpan: (e) => e.rowSpan || 1
      },
      {
        title: "K3编码",
        key: "orgK3Code",
        width: 100,
        rowSpan: (e) => e.rowSpan || 1
      },
      {
        title: "招商渠道",
        key: "orgChannelName",
        width: 140
      },
      // {
      //   title: '促销类型',
      //   key: 'orgPromotionType',
      //   width:160,
      //   render: (row:any) => {
      //     // 转换促销类型为字典标签
      //     const promotionLabel = getDictLabelSync(row.orgPromotionType, 'ROOT_PromotionType') || row.orgPromotionType
      //     return h('div', { innerHTML: promotionLabel })
      //   }
      // }
      {
        title: "促销类型",
        key: "orgPromotionType",
        render: (e) => {
          const t = (e.orgPromotionType || "").split(/,/).filter(Boolean);
          console.log("typeList", t);
          const l = t.map((g) => re(g, "ROOT_PromotionType") || g);
          let s, d;
          return l.length <= 5 ? (s = l.join(","), T("span", {
            innerHTML: s
          })) : (s = l.slice(0, 5).join(",") + "...", d = l.join(","), T(se, {
            trigger: "hover",
            placement: "top",
            showArrow: !0,
            teleport: S
          }, {
            trigger: () => T("span", {
              innerHTML: s
            }),
            default: () => T("div", {
              innerHTML: d
            })
          }));
        }
      }
    ], F = (e) => {
      y.value && e.length > 1 ? r.value = [e[e.length - 1]] : r.value = e;
    }, u = h({
      fictitiousShopId: "",
      orgId: "",
      brand: "",
      category: "",
      productChannel: "",
      promotionType: "",
      sendOrderStatus: "",
      notIncludeOrgBelongMarketClassifyList: "",
      oldOrderStatus: "",
      normalOrderStatus: "",
      orgBelongMarketClassifyList: ""
    });
    de(() => K(this, null, function* () {
    }));
    const $ = () => K(this, null, function* () {
      try {
        O.value = !0, yield le("ROOT_PromotionType");
        const e = yield ne(u.value);
        if (e && e.data && e.status) {
          O.value = !1;
          const n = e.data || [];
          console.log(n);
          const t = /* @__PURE__ */ new Map();
          n.forEach((d) => {
            var f;
            const g = d.orgMarketManageRightCode;
            t.has(g) || t.set(g, []), (f = t.get(g)) == null || f.push(d);
          });
          const l = [];
          let s = 0;
          if (t.forEach((d) => {
            if (d.length === 0)
              return;
            const g = d[0], f = [];
            d.forEach((M) => {
              var q, P;
              const L = ((q = M.orgChannelName) == null ? void 0 : q.split("、")) || [], N = ((P = M.orgPromotionType) == null ? void 0 : P.split("、")) || [], Y = Math.max(L.length, N.length);
              for (let I = 0; I < Y; I++) {
                const _ = L[I] || "", B = N[I] || "";
                _ && B && (f.find((D) => D.channel === _ && D.promotion === B) || f.push({
                  channel: _,
                  promotion: B
                }));
              }
            }), f.length === 0 && f.push({
              channel: "",
              promotion: ""
            }), f.forEach((M, L) => {
              const N = j(x({}, g), {
                orgChannelName: M.channel,
                orgPromotionType: M.promotion,
                uniqueKey: `row_${s++}`,
                // 为每一行创建唯一key
                rowSpan: L === 0 ? f.length : 0
                // 第一行设置rowSpan，其他行设置为0
              });
              l.push(N);
            });
          }), i.value = l, console.log("dataTable.value", i.value), console.log("autoSelectId", v.value), v.value) {
            const d = i.value.find((g) => g.orgMarketManageRightId === v.value && g.rowSpan > 0);
            console.log("targetRow", d), d && (r.value = [d.uniqueKey]);
          }
        } else
          console.warn("获取数据失败：response 或 data 为空"), C.error((e == null ? void 0 : e.message) || "获取数据失败"), i.value = [], p.value = 0;
      } catch (e) {
        O.value = !1, console.error("请求失败:", e), i.value = [], p.value = 0;
      }
    });
    let b = null;
    function G(e) {
      r.value = [], u.value.fictitiousShopId = e.fictitiousShopId || "", u.value.orgId = e.orgId || "", u.value.brand = e.brand || "", u.value.category = e.category || "", u.value.productChannel = e.productChannel || "", u.value.sendOrderStatus = e.sendOrderStatus || "", u.value.notIncludeOrgBelongMarketClassifyList = e.notIncludeOrgBelongMarketClassifyList || "", u.value.oldOrderStatus = e.oldOrderStatus || "", u.value.normalOrderStatus = e.normalOrderStatus || "", u.value.orgBelongMarketClassifyList = e.orgBelongMarketClassifyList || "", u.value.promotionType = e.promotionType || "", v.value = e.orgMarketManageRightId || "", y.value = !0, $(), m.value = !0;
    }
    const J = () => {
      m.value = !1, b = null, v.value = "", u.value = {
        fictitiousShopId: "",
        orgId: "",
        brand: "",
        category: "",
        productChannel: "",
        promotionType: "",
        sendOrderStatus: "",
        notIncludeOrgBelongMarketClassifyList: "",
        oldOrderStatus: "",
        normalOrderStatus: "",
        orgBelongMarketClassifyList: ""
      };
    }, Q = () => {
      if (r.value.length === 0) {
        C.warning("至少选择一条数据");
        return;
      }
      m.value = !1;
      const e = i.value.filter((n) => r.value.includes(n.uniqueKey)).map((n) => {
        const t = x({}, n);
        return delete t.uniqueKey, delete t.rowSpan, t;
      });
      W("submit", e);
    }, W = o, X = () => {
      m.value = !1, v.value = "", b && (b([]), b = null);
    };
    return a({
      open: G
    }), (e, n) => (ce(), ge(pe, null, [V("div", {
      ref_key: "relatedApprovalContainer",
      ref: S
    }, null, 512), w(k(ve), {
      bordered: "",
      show: m.value,
      "onUpdate:show": n[0] || (n[0] = (t) => m.value = t),
      "mask-closable": !1,
      "z-index": 9999,
      to: S.value || "body"
    }, {
      default: R(() => [w(k(me), {
        show: O.value
      }, {
        default: R(() => [w(k(he), {
          style: {
            width: "1400px"
          },
          title: "经营权列表",
          bordered: !1,
          role: "dialog",
          closable: "",
          onClose: J
        }, {
          default: R(() => [w(k(ye), {
            columns: U,
            data: i.value,
            bordered: "",
            "onUpdate:checkedRowKeys": F,
            "row-key": (t) => t.uniqueKey,
            "checked-row-keys": r.value
          }, null, 8, ["data", "row-key", "checked-row-keys"]), V("div", ke, [w(k(H), {
            onClick: X,
            size: "small"
          }, {
            default: R(() => n[1] || (n[1] = [z("取消", -1)])),
            _: 1,
            __: [1]
          }), w(k(H), {
            onClick: Q,
            size: "small",
            style: {
              "margin-left": "30px"
            },
            type: "primary"
          }, {
            default: R(() => n[2] || (n[2] = [z("确定", -1)])),
            _: 1,
            __: [2]
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["show"])]),
      _: 1
    }, 8, ["show", "to"])], 64));
  }
});
export {
  Pe as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/manage-mentList/ManagementList.vue.js
// module id = 1264
// module chunks = 41